import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHYCSSecureAccountData, type EnrollmentHYCSSecureAccountSubmitOutput } from '../../../../models'

export const getEnrollmentHYCSSecureAccountDataMock: EnrollmentHYCSSecureAccountData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/secure-account`',
  enrollmentData: {
    applicationId: '305802305',
    passkeyPublicKeyCredentialRequestOptions: JSON.stringify({
      rp: { name: 'Evergreen Wealth', id: 'localhost' },
      user: {
        name: 'nick+wh@evergreen.money',
        displayName: 'Nick Navarro',
        id: 'dXNlci0wOTU3YTZjOC1iZmY1LTQ3ZDctYTMwMC05MWI4NjAwNWE4YWQ',
      },
      challenge: '1riMFgLYB9oUt5qtChOAuL-BL9hs_U6myyI5Qov9Mh4',
      pubKeyCredParams: [
        { alg: -7, type: 'public-key' },
        { alg: -8, type: 'public-key' },
        { alg: -35, type: 'public-key' },
        { alg: -36, type: 'public-key' },
        { alg: -257, type: 'public-key' },
        { alg: -258, type: 'public-key' },
        { alg: -259, type: 'public-key' },
      ],
      excludeCredentials: [],
      authenticatorSelection: {
        requireResidentKey: false,
        residentKey: 'preferred',
        userVerification: 'preferred',
      },
      attestation: 'direct',
      extensions: { credProps: true },
    }),
  },
}

export const submitEnrollmentHYCSSecureAccountDataMock: EnrollmentHYCSSecureAccountSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/disclosures',
  enrollmentData: {
    passkeyRegistered: true,
  },
}

export const mockGetEnrollmentHYCSSecureAccountData = graphql.mutation('getEnrollmentHYCSSecureAccountData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSSecureAccountDataMock } })
})

export const mockGetEnrollmentPasskeyCredentials = graphql.mutation('getEnrollmentPasskeyCredentialOptions', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSSecureAccountDataMock } })
})

export const mockSubmitEnrollmentHYCSSecureAccountData = graphql.mutation(
  'submitEnrollmentHYCSSecureAccountData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSSecureAccountDataMock } })
  },
)

export const mockEnrollmentHYCSSecureAccount = [
  mockGetEnrollmentHYCSSecureAccountData,
  mockSubmitEnrollmentHYCSSecureAccountData,
  mockGetEnrollmentPasskeyCredentials,
]
